/** Canonical site URL for SEO (sitemap, canonical, Open Graph). Set in production via .env */
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://plaatplan.nl").replace(/\/$/, "");

export const SITE_NAME = "Plaatplan";

export const DEFAULT_TITLE = "Plaatplan | Gratis zaagplan maken voor MDF en multiplex";

export const DEFAULT_DESCRIPTION =
  "Maak gratis een zaagplan voor MDF, multiplex, spaanplaat en meubelpaneel. Plaatplan deelt je panelen in op standaardplaten, telt hoeveel platen je nodig hebt en levert een werkplan voor de bouwmarkt of zaagservice.";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-preview.png`;

/** Bronbestand: public/og-preview.svg (npm run og:preview) */

export const OG_IMAGE_WIDTH = 1200;

export const OG_IMAGE_HEIGHT = 630;

export const OG_IMAGE_ALT =
  "Plaatplan: zaagindeling op een plaat met panelen en resultaat met aantal platen en benutting";
